import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icons } from '../atoms/icons';
export const SearchField = observer(({ searchFieldSvc }) => {
    const { t } = useTranslation();
    return (_jsx(TextField, { fullWidth: true, sx: { '& .MuiInputBase-root': { paddingLeft: '8px', paddingRight: '8px' } }, variant: "filled", placeholder: t('SEARCH_DIALOG_PLACEHOLDER'), onChange: searchFieldSvc.handleChange, value: searchFieldSvc.value || '', InputProps: {
            startAdornment: _jsx(Icons.Search, { color: "info" }),
            endAdornment: (_jsx(IconButton, { sx: { padding: 0 }, edge: "end", onClick: searchFieldSvc.handleClear, children: _jsx(Icons.Close, { color: "primary" }) })),
        } }));
});
